<template>
  <div>
    <div class="group">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="98.77" height="50.454" viewBox="0 0 98.77 50.454">
        <defs>
          <filter id="CreditRateGraph" x="0" y="0" width="29.727" height="50.454" filterUnits="userSpaceOnUse">
            <feOffset dy="2" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="2" result="blur"/>
            <feFlood flood-color="#a8a8a8" flood-opacity="0.502"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
        </defs>
        <g id="Graph" transform="translate(6 4)">
          <rect id="Rectangle_Copy_35" data-name="Rectangle Copy 35" width="96.905" height="0.592" transform="translate(-5.908 38.454)" fill="#e6e6e6"/>
          <rect id="Rectangle_Copy_36" data-name="Rectangle Copy 36" width="96.905" height="0.592" transform="translate(-4.727 1.183)" fill="#e6e6e6"/>
          <rect id="Rectangle_Copy_37" data-name="Rectangle Copy 37" width="96.905" height="0.592" transform="translate(-4.727 20.114)" fill="#e6e6e6"/>
          <g transform="matrix(1, 0, 0, 1, -6, -4)" filter="url(#CreditRateGraph)">
            <path id="CreditRateGraph-2" data-name="Rectangle Copy 38" d="M6,0h5.727a6,6,0,0,1,6,6V38.454a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z" transform="translate(6 4)" fill="#0089e5"/>
          </g>
          <path id="Rectangle_Copy_39" data-name="Rectangle Copy 39" d="M6,0H9.363a6,6,0,0,1,6,6V32.538a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z" transform="translate(20.681 5.916)" fill="#0089e5" opacity="0.5"/>
          <path id="Rectangle_Copy_40" data-name="Rectangle Copy 40" d="M6,0H8.772a6,6,0,0,1,6,6V28.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z" transform="translate(40.18 10.057)" fill="#0089e5" opacity="0.5"/>
          <path id="Rectangle_Copy_41" data-name="Rectangle Copy 41" d="M6,0H8.772a6,6,0,0,1,6,6V22.481a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z" transform="translate(59.68 15.973)" fill="#0089e5" opacity="0.5"/>
          <path id="Rectangle_Copy_42" data-name="Rectangle Copy 42" d="M6,0H8.772a6,6,0,0,1,6,6V7.691a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z" transform="translate(77.997 30.763)" fill="#0089e5" opacity="0.5"/>
        </g>
      </svg>

    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
  components: {
    LottieAnimation,
  },
  props: {
    index: {default: 0},
  },
};
</script>

<style lang="scss" scoped>
.group {
  //height: 5em;

}

// .bar {
//   border-top-left-radius: 30%;
//   border-top-right-radius: 30%;
//   margin-right: 0.2em;
//   background-color: #7fc4f2;

//   width: 0.8em;
//   &.active-bar {
//     background-color: #0089e5;
//   }
//   &.bar-0 {
//     height: 0.5em;
//     position: relative;
//     bottom: -2em;
//   }
//   &.bar-1 {
//     height: 1em;
//     position: relative;
//     bottom: -1.5em;
//   }
//   &.bar-2 {
//     height: 1.5em;
//     position: relative;
//     bottom: -1em;
//   }
//   &.bar-3 {
//     height: 2em;
//     position: relative;
//     bottom: -0.5em;
//   }
//   &.bar-4 {
//     height: 2.5em;
//   }
// }
</style>